import { cashBalanceComponents } from "./cashballist/navigationComponents";
import { newsComponents } from "../reports/news/navigationComponents";
import { dividendsComponents } from "../reports/dividends/navigationComponents";

export const reportsComponents = [
    ...cashBalanceComponents,
	...newsComponents,
    ...dividendsComponents,
];
